export const numberPoint = (x) => (x || 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")